import { additional_colors } from '../additional-colors';
function containedStyle(color) {
    return {
        backgroundColor: color.main,
        color: color.contrastText,
        '&:hover, &.Mui-focusVisible': {
            backgroundColor: color.dark,
            // '& .MuiIconButton-root, .MuiListItemSecondaryAction-root': {
            //     backgroundColor: color.dark,
            // },
        },
        '& .MuiListItemText-primary, .MuiListItemText-secondary, .MuiSvgIcon-root, .MuiListItemSecondaryAction-root': {
            color: color.contrastText,
        },
    };
}
const colors = [...additional_colors, 'error', 'warning', 'info', 'success'];
export function getListButtonVariants(theme_colors) {
    return colors.flatMap((color) => [
        {
            props: { color },
            style: containedStyle(theme_colors[color]),
        },
    ]);
}
function containedStyleList(color) {
    return {
        backgroundColor: color.main,
        color: color.contrastText,
        '& .MuiListItemText-primary, .MuiListItemText-secondary, .MuiSvgIcon-root, .MuiIconButton-root': {
            color: color.contrastText,
        },
    };
}
export function getListVariants(theme_colors) {
    return colors.flatMap((color) => [
        {
            props: { color },
            style: containedStyleList(theme_colors[color]),
        },
    ]);
}
function containedStyle2(color) {
    return {
        '& .MuiSvgIcon-root': {
            color: color.contrastText,
        },
    };
}
export function getSecondaryActionsVariants(theme_colors) {
    return colors.flatMap((color) => [
        {
            props: { color },
            style: containedStyle2(theme_colors[color]),
        },
    ]);
}
